// Stable Accordion item values for the agent-jobs sections rendered when the
// panel is embedded in the Copilot Tasks Hub.
import loc, { type LocalizedString } from "owa-localize";
import { agentJobsAutomationsHeader, agentJobsWorkflowsHeader, } from "./embeddedSectionIds.locstring.json";

export const AGENT_JOBS_AUTOMATIONS_SECTION_ID = "agent-jobs-automations";
export const AGENT_JOBS_WORKFLOWS_SECTION_ID = "agent-jobs-workflows";

// Localized section headers, exposed from this import-free leaf so the host
// drawer can label the Tasks Hub sections without importing (and eagerly
// evaluating) the panel chunk. Called at render time so the culture is current.
export const getAgentJobsWorkflowsHeader = (): LocalizedString => loc(agentJobsWorkflowsHeader);
export const getAgentJobsAutomationsHeader = (): LocalizedString => loc(agentJobsAutomationsHeader);
